// extracted by mini-css-extract-plugin
export var option = "_52-1";
export var optionActive = "_52-2";
export var pill = "_52-0";